import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

export const Donate = () => (

    <Container className="text-center">
        <main id="home" className="container mb-5">
            <Row className='bg-light row justify-content-md-center align-items-center my-5 py-5'>
                <Col md={5}>
                    <p> <a className="nav-link" href="https://openspaceinstitute.org/support-our-work/citizenaction"
                        rel="noopener noreferrer" target="_blank"><span
                            className="badge bg-warning fs-1">Donate</span></a></p>
                </Col>
                <Col md={7}>
                    <p className="lead">Your contribution supports a kaleidoscope of initiatives that make the St
                        Nicholas Miracle Garden more than just a green space - it's a thriving center of community,
                        culture, and sustainability.</p>
                    <p>Join us in making a difference by donating today!</p>
                </Col>

            </Row>

            <Row className="row py-5 mb-5 bg-light">
                <h2>Why Support Our Community Garden?</h2>
                <Col md={6}>
                    <h3>Empowering Youth</h3>
                    <p>Through our Youth Gardener Program, we provide a nurturing
                        environment for the younger generation to learn about horticulture, teamwork, and
                        responsibility. Your donation supports educational materials, tools, and mentorship for our
                        aspiring young gardeners.</p>
                </Col>
                <Col md={6}>
                    <h3>Fresh Produce for All</h3>
                    <p>Our Farm Stand and Community Supported Agriculture
                        (CSA) programs provide Harlem residents with fresh, locally grown produce. Your contribution
                        helps us maintain these programs, ensuring our community has access to nutritious and
                        affordable food options.</p>
                </Col>
                <Col md={6}>
                    <h3>Live Music and Performances</h3>
                    <p>Immerse yourself in the vibrant culture of Harlem by supporting our live music and garden performances. Your donation helps us bring talented artists to our community, creating an inclusive space for everyone to enjoy.</p>
                </Col>
                <Col md={6}>
                    <h3>Compost Project Programs</h3>
                    <p>Join us in the cycle of sustainability by
                        supporting our compost project programs. Your donation helps us expand our composting
                        initiatives, reducing waste and enriching our soil for even more bountiful harvests.</p>
                </Col>
                <Col md={12}>

                    <p>Stay tuned to our <a href="https://www.instagram.com/stnicksgarden/" rel="noopener noreferrer"
                        target="_blank"><i className="fab fa-instagram fa-lg"></i></a>
                        <a href="https://www.facebook.com/stnicksgarden" rel="noopener noreferrer" target="_blank">
                            <i className="fab fa-facebook-f fa-lg"></i></a> for more information and updates.</p>

                    {/* <p>Stay tuned to our <a href="https://www.instagram.com/stnicksgarden/" rel="noopener noreferrer"
                            target="_blank"><i className="fab fa-instagram fa-lg"></i></a> <a
                                href="https://www.facebook.com/stnicksgarden" rel="noopener noreferrer" target="_blank"><i
                                    className="fab fa-facebook-f fa-lg"></i></a> for more information and updates.</p> */}
                </Col>
            </Row>

            <Row className="row py-5 mb-5 bg-light">
                <h2 className="my-4">Your Donation - Growing More Than Gardens</h2>
                <Row className="row justify-content-md-center">
                    <Col md={6}>
                        <h3>Youth Empowerment</h3>
                        <p>Support the next generation of gardeners and leaders by
                            funding
                            tools, educational workshops, and mentorship for our Youth Gardener Program.</p>
                    </Col>
                    <Col md={6}>
                        <h3>Fresh Food Access</h3>
                        <p>Contribute to our Farm Stand and CSA programs to ensure our community has continuous access to fresh, locally sourced produce.</p>
                    </Col>
                    <Col md={6}>
                        <h3>Cultural Enrichment</h3>
                        <p>Help us organize vibrant live music and performances that unite the community through creativity and celebration.</p>
                    </Col>
                    <Col md={6}>
                        <h3>Sustainability Initiatives</h3>
                        <p>Back our composting project programs to enable a more sustainable Harlem, reduce waste, and enhance our garden's ecological impact.</p>
                    </Col>
                </Row>
            </Row>

            <Row className="row py-5 mb-5 bg-light">
                <h2 className="my-4">Donate Now to Cultivate Unity and Joy in Harlem!</h2>
                <p className="lead">Your contribution supports a kaleidoscope of initiatives that make the Heart of Harlem
                    Community Garden more
                    than just a green space - it's a thriving center of community, culture, and sustainability.</p>
                <p><a className="nav-link" href="https://openspaceinstitute.org/support-our-work/citizenaction"
                    rel="noopener noreferrer" target="_blank"><span className="badge bg-warning fs-1">Donate</span></a>
                </p>
                <p>Thank you for helping us cultivate unity, sustainability, and joy in the heart of Harlem!</p>
            </Row>
        </main>
    </Container>

)